export const getDateFormat = () => {
    const locale = navigator.language;

    switch (locale.toLowerCase()) {
        case "en-us":
        case "en-ph":
        case "en-pw":
        case "en-fm":
        case "en-mh":
        case "en-bz":
        case "en-ca":
            return "MM/DD";
        default:
            return "DD/MM";
    }
};
